'use client';

import { useEffect, useState } from 'react';

/**
 * Wechselt alle 5 Sekunden für 10 Sekunden zwischen Standardtext und Promotiontext.
 */
export default function RotatingBanner() {
  const [showPromo, setShowPromo] = useState(false);

  useEffect(() => {
    const promoCycle = () => {
      setShowPromo(true);
      const hideTimeout = setTimeout(() => setShowPromo(false), 10000); // 10 Sekunden sichtbar

      return hideTimeout;
    };

    const interval = setInterval(promoCycle, 15000); // Alle 15 Sekunden starten
    const initialTimeout = promoCycle(); // erster sofortiger Start

    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);

  return (
    <div className="w-full bg-primary text-white py-2 text-center font-medium">
      {showPromo ? (
        <>
          <span className="hidden md:inline">
            Die einzige Plattform mit <strong>1:1 Video-Beratung</strong> & <strong>Gruppensitzungen</strong>.{' '}
            <a href="/products" className="underline hover:text-gray-200">
              Jetzt entdecken
            </a>
          </span>
          <span className="md:hidden">
            Video- & Gruppensitzungen!{' '}
            <a href="/products" className="underline hover:text-gray-200">
              Jetzt ansehen
            </a>
          </span>
        </>
      ) : (
        <>
          <span className="hidden md:inline">
            Jetzt 10 % Rabatt auf deine erste Beratung sichern! Nur für kurze Zeit – Code: <strong>WELCOME10</strong>
          </span>
          <span className="md:hidden">
            10 % Rabatt! Nur für kurze Zeit: <strong>WELCOME10</strong>
          </span>
        </>
      )}
    </div>
  );
}
